module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "vehicle-edit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Meus planos "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + " "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Veículos "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Editar Veículo")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })], 1)]), _vm._v(" "), (_vm.vehicle) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-xs-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box margin-20 box-content-padding",
    attrs: {
      "id": "box-category"
    }
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Quantidade de eixos:")]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t5"
  }, [_c('div', {
    staticClass: "col-md-3 small-padding-right"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 1, 'disabled': _vm.axesSelected != 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "2-simple-axis",
      "type": "radio",
      "name": "radio",
      "value": "1",
      "disabled": _vm.axesSelected != 1
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "1")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "2-simple-axis"
    }
  }, [_vm._v("2 Eixos - Simples")]), _vm._v(" "), _c('div', {
    staticClass: "check first"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 7, 'disabled': _vm.axesSelected != 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "3-simple-axis",
      "type": "radio",
      "name": "radio",
      "value": "7",
      "disabled": _vm.axesSelected != 1
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "7")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "7"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "3-simple-axis"
    }
  }, [_vm._v("3 Eixos - Simples")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 8, 'disabled': _vm.axesSelected != 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "4-simple-axis",
      "type": "radio",
      "name": "radio",
      "value": "8",
      "disabled": _vm.axesSelected != 1
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "8")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "8"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "4-simple-axis"
    }
  }, [_vm._v("4 Eixos - Simples")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 2, 'disabled': _vm.axesSelected == 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "2-double-axis",
      "type": "radio",
      "name": "radio",
      "value": "2",
      "disabled": _vm.axesSelected == 1
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "2")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "2"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "2-double-axis"
    }
  }, [_vm._v("2 Eixos - Duplos")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 small-padding-right"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 3, 'disabled': _vm.axesSelected == 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "3-double-axis",
      "type": "radio",
      "name": "radio",
      "value": "3",
      "disabled": _vm.axesSelected == 1
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "3")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "3-double-axis"
    }
  }, [_vm._v("3 Eixos - Duplos")]), _vm._v(" "), _c('div', {
    staticClass: "check first"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 4, 'disabled': _vm.axesSelected == 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "4-double-axis",
      "type": "radio",
      "name": "radio",
      "value": "4",
      "disabled": _vm.axesSelected == 1
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "4")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "4-double-axis"
    }
  }, [_vm._v("4 Eixos - Duplos")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 5, 'disabled': _vm.axesSelected != 6
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "5-double-axis",
      "type": "radio",
      "name": "radio",
      "value": "5",
      "disabled": _vm.axesSelected != 6
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "5")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "5-double-axis"
    }
  }, [_vm._v("5 Eixos - Duplos")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 6, 'disabled': _vm.axesSelected != 6
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "6-double-axis",
      "type": "radio",
      "name": "radio",
      "value": "6",
      "disabled": _vm.axesSelected != 6
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "6")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "6"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "6-double-axis"
    }
  }, [_vm._v("6 Eixos - Duplos")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 small-padding-right"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 9, 'disabled': _vm.axesSelected != 6
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "7-double-axis",
      "type": "radio",
      "name": "radio",
      "value": "9",
      "disabled": _vm.axesSelected != 6
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "9")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "9"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "7-double-axis"
    }
  }, [_vm._v("7 Eixos - Duplos")]), _vm._v(" "), _c('div', {
    staticClass: "check first"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 10, 'disabled': _vm.axesSelected != 6
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "8-double-axis",
      "type": "radio",
      "name": "radio",
      "value": "10",
      "disabled": _vm.axesSelected != 6
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "10")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "10"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "8-double-axis"
    }
  }, [_vm._v("8 Eixos - Duplos")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category axis-box",
    class: {
      'active': _vm.radioSelected == 11, 'disabled': _vm.axesSelected != 6
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "9-double-axis",
      "type": "radio",
      "name": "radio",
      "value": "11",
      "disabled": _vm.axesSelected != 6
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "11")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "11"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "9-double-axis"
    }
  }, [_vm._v("9 Eixos - Duplos")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-left"
  }, [_c('div', {
    staticClass: "radio-box category box-other-axis",
    class: {
      'active': _vm.radioSelected == -1, 'disabled': _vm.axesSelected == 3 || _vm.axesSelected == 1
    },
    attrs: {
      "id": "box-other-axis"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioSelected),
      expression: "radioSelected"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "other-axis",
      "type": "radio",
      "name": "radio",
      "value": "-1",
      "disabled": _vm.axesSelected == 3 || _vm.axesSelected == 1
    },
    domProps: {
      "checked": _vm._q(_vm.radioSelected, "-1")
    },
    on: {
      "change": function($event) {
        _vm.radioSelected = "-1"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label radio-label-fix",
    attrs: {
      "for": "other-axis"
    }
  }, [_vm._v("Outros")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  }), _vm._v(" "), _c('dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radioSelected == -1),
      expression: "radioSelected == -1"
    }],
    staticClass: "dropdown-lg",
    attrs: {
      "options": _vm.otherCategories,
      "value": _vm.otherCategorySelected
    },
    model: {
      value: (_vm.otherCategorySelected),
      callback: function($$v) {
        _vm.otherCategorySelected = $$v
      },
      expression: "otherCategorySelected"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "margin-t20",
    attrs: {
      "id": "axes-category"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 small-padding-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "bold-600 no-margin",
    attrs: {
      "for": "plate"
    }
  }, [_vm._v("Placa:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.plate),
      expression: "vehicle.plate"
    }],
    staticClass: "form-control text-uppercase plate margin-t5",
    attrs: {
      "id": "plate",
      "maxlength": "7",
      "type": "text",
      "name": "plate",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicle.plate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicle, "plate", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Marca:")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-lg margin-t5",
    attrs: {
      "options": _vm.brands,
      "value": _vm.brandSelected
    },
    on: {
      "itemSelected": _vm.loadModels
    },
    model: {
      value: (_vm.brandSelected),
      callback: function($$v) {
        _vm.brandSelected = $$v
      },
      expression: "brandSelected"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small-padding-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Modelo:")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-lg margin-t5",
    attrs: {
      "options": _vm.models
    },
    on: {
      "itemSelected": _vm.onModelSelected
    },
    model: {
      value: (_vm.modelSelected),
      callback: function($$v) {
        _vm.modelSelected = $$v
      },
      expression: "modelSelected"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 small-padding-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "bold-600 no-margin",
    attrs: {
      "for": "plate"
    }
  }, [_vm._v("Renavam:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.renavam),
      expression: "vehicle.renavam"
    }],
    staticClass: "form-control text-uppercase  margin-t5 vehicle-edit-input",
    attrs: {
      "type": "text",
      "name": "renavam"
    },
    domProps: {
      "value": (_vm.vehicle.renavam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicle, "renavam", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rntrc')
    }
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("RNTRC:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal|max:12'),
      expression: "'decimal|max:12'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.rntrc),
      expression: "vehicle.rntrc"
    }, {
      name: "only-numbers",
      rawName: "v-only-numbers"
    }],
    staticClass: "form-control text-uppercase margin-t5 vehicle-edit-input",
    attrs: {
      "maxlength": "12",
      "type": "text",
      "name": "rntrc"
    },
    domProps: {
      "value": (_vm.vehicle.rntrc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicle, "rntrc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('rntrc')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small-padding-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-lg margin-t5",
    attrs: {
      "options": _vm.states,
      "value": _vm.vehicle.state
    },
    model: {
      value: (_vm.vehicle.state),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "state", $$v)
      },
      expression: "vehicle.state"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 small-padding-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "bold-600 no-margin",
    attrs: {
      "for": "plate"
    }
  }, [_vm._v("Ano de fabricação:")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-lg margin-t5",
    attrs: {
      "options": _vm.years,
      "value": _vm.vehicle.assemblyYear
    },
    model: {
      value: (_vm.vehicle.assemblyYear),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "assemblyYear", $$v)
      },
      expression: "vehicle.assemblyYear"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Ano do modelo:")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-lg margin-t5",
    attrs: {
      "options": _vm.years,
      "value": _vm.vehicle.modelYear
    },
    model: {
      value: (_vm.vehicle.modelYear),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "modelYear", $$v)
      },
      expression: "vehicle.modelYear"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small-padding-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Cor:")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-lg margin-t5",
    attrs: {
      "options": _vm.colors,
      "value": _vm.vehicle.color
    },
    model: {
      value: (_vm.vehicle.color),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "color", $$v)
      },
      expression: "vehicle.color"
    }
  })], 1)])]), _vm._v(" "), (_vm.vehicle.rntrc) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 small-padding-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "bold-600 no-margin",
    attrs: {
      "for": "ownFleet"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownFleet),
      expression: "ownFleet"
    }],
    attrs: {
      "id": "ownFleet",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ownFleet) ? _vm._i(_vm.ownFleet, null) > -1 : (_vm.ownFleet)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ownFleet,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ownFleet = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ownFleet = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ownFleet = $$c
        }
      }
    }
  }), _vm._v(" Frota própria")])])])]) : _vm._e(), _vm._v(" "), (!_vm.ownFleet && _vm.vehicle.rntrc) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 small-padding-right"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxpayerIdNumber')
    }
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("CPF/CNPJ:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.taxpayerIdNumber),
      expression: "driver.taxpayerIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:18|cpfCnpj'),
      expression: "'required|max:18|cpfCnpj'"
    }, {
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }],
    staticClass: "form-control text-uppercase margin-t5 vehicle-edit-input",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
      "name": "taxpayerIdNumber",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.driver.taxpayerIdNumber)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "taxpayerIdNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('taxpayerIdNumber')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 small-padding-right small-padding-left"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.driverName),
      expression: "driver.driverName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-uppercase margin-t5 vehicle-edit-input",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.driver.driverName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.driver, "driverName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('name')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small-padding-left"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.driverEmail),
      expression: "driver.driverEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control text-uppercase margin-t5 vehicle-edit-input",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.driver.driverEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.driver, "driverEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('email')) + "\n                  ")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 pull-right"
  }, [(_vm.vehicle.installDate) ? _c('div', {
    staticClass: "col-md-6",
    class: _vm.classVehicle
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Ativado em: ")]), _vm._v(_vm._s(_vm._f("dateTime")(_vm.vehicle.installDate)))]) : _vm._e(), _vm._v(" "), (_vm.vehicle.cancelDate) ? _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Cancelado em: ")]), _vm._v(" " + _vm._s(_vm._f("dateTime")(_vm.vehicle.cancelDate)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-7 box-button"
  }, [_c('router-link', {
    staticClass: "btn btn-back btn-edit-vehicle",
    attrs: {
      "to": {
        name: 'contract-vehicles',
        params: {
          id: _vm.contractId
        }
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v(" Voltar\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-5 box-buttons"
  }, [_c('router-link', {
    staticClass: "btn-icon-left btn-danger btn-edit-vehicle",
    attrs: {
      "to": {
        name: 'contract-vehicles',
        params: {
          contractId: _vm.contractId
        }
      },
      "tag": "button",
      "type": "button"
    }
  }, [_vm._v("\n              Cancelar\n              "), _c('i', {
    staticClass: "icon-circle-left align-icon-left-white"
  })]), _vm._v(" "), _vm._m(0)], 1)])])])]) : _c('div', {
    staticClass: "row margin-t20"
  }, [_vm._v("\n    Carregando veículo... Por favor aguarde...\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn-icon-right btn-success btn-edit-vehicle",
    attrs: {
      "type": "submit",
      "title": ""
    }
  }, [_vm._v("\n              Salvar\n              "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-sm no-top"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-249abb56!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/vehicle-edit.vue
// module id = 2068
// module chunks = 1